<template>
  <div id="app">
    <router-view></router-view>
    <loading v-if="showLoading"/>
    <DSError :showing="errorShow" :okCallback="alertList.okCallback" :cancelCallback="alertList.cancelCallback" :title2="alertList.title2" :title1="alertList.title1" :title="alertList.title" :errorCancel="alertList.errorCancel"></DSError>
    <cp-alert-view :okCallback="cityAlert.okCallback" :cancelAlert="cityAlert.cancelAlert" id="cityAlertView" v-if="cityAlert.show" :title="cityAlert.title">
    </cp-alert-view>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    name: 'app',
    data(){
      return {}
    },
    components: {},
    computed: {
      ...mapState({
        showLoading: state => state.RootModule.showLoading,
        errorShow: state => state.RootModule.alertOptions.show,
        alertList: state => state.RootModule.alertOptions.alertList,
        cityAlert: state => state.RootModule.cityAlert,
        noSignal: state => state.RootModule.noSignal.signalList,
        signalShow:state => state.RootModule.noSignal.show,
        activityShow:state => state.RootModule.activitySignal.show,
        activitySignal: state => state.RootModule.activitySignal.activityList
      })
    }
  }
  </script>

  <style>
    h1,h2,h3,h4,h5,h6{font-weight:normal}
    body > iframe{
      display: none;
    }
    input, button{
      outline: none;
      cursor: pointer;
    }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #000;
  }
    body,html{
      -webkit-touch-callout:none;  /*系统默认菜单被禁用*/
      -webkit-user-select:none; /*webkit浏览器*/
      -khtml-user-select:none; /*早期浏览器*/
      -moz-user-select:none;/*火狐*/
      -ms-user-select:none; /*IE10*/
      user-select:none;
    }
  </style>
